import { render, staticRenderFns } from "./RewardPicture.vue?vue&type=template&id=3a1834e5&"
import script from "./RewardPicture.vue?vue&type=script&lang=js&"
export * from "./RewardPicture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a1834e5')) {
      api.createRecord('3a1834e5', component.options)
    } else {
      api.reload('3a1834e5', component.options)
    }
    module.hot.accept("./RewardPicture.vue?vue&type=template&id=3a1834e5&", function () {
      api.rerender('3a1834e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/Stamp/components/RewardPicture.vue"
export default component.exports